import { Box, Button, Chip, Stack, Typography } from '@mui/material';
import type { SeasonMatchReadiness as Readiness } from '../utils/seasonSetupClient';

const labels: Record<keyof Readiness['dimensions'], string> = {
  identity: 'Provider match identity', players: 'Player mappings', verification: 'Captain verification',
  schedule: 'Schedule conflicts', discovery: 'Scorecard discovery', results: 'Official results',
  eligibility: 'Result-write eligibility',
};

export function SeasonMatchReadiness({ readiness, onReviewSaved, onReviewMappings, disabled = false }: {
  readiness: Readiness; onReviewSaved: () => void; onReviewMappings: () => void; disabled?: boolean;
}) {
  return <Stack spacing={1}>
    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1} alignItems={{ xs: 'flex-start', sm: 'center' }}>
      <Chip size="small" color={readiness.severity} label={readiness.primary} />
      <Typography variant="body2" color={readiness.severity === 'warning' ? 'warning.main' : 'text.secondary'}>{readiness.summary}</Typography>
    </Stack>
    <Box component="details" sx={{ '& > summary': { cursor: 'pointer' } }}>
      <Typography component="summary" variant="body2">Readiness details</Typography>
      <Stack spacing={1} sx={{ pt: 1 }}>
        {(Object.keys(labels) as (keyof typeof labels)[]).map(key => <Box key={key}>
          <Typography variant="body2"><Box component="span" sx={{ fontWeight: 700 }}>{labels[key]}: </Box>{readiness.dimensions[key].state}</Typography>
          <Typography variant="caption" color="text.secondary">{readiness.dimensions[key].detail}</Typography>
        </Box>)}
        <Typography variant="caption">Last discovery attempt: {readiness.lastDiscoveryAttempt ? new Date(readiness.lastDiscoveryAttempt).toLocaleString() : 'No attempt recorded'}</Typography>
        <Typography variant="caption">Last provider result check: {readiness.lastProviderCheck ? new Date(readiness.lastProviderCheck).toLocaleString() : 'No check recorded'}</Typography>
      </Stack>
    </Box>
    {readiness.actions.length > 0 && <Stack direction="row" spacing={1} useFlexGap flexWrap="wrap">
      {readiness.actions.map(action => <Button key={action.kind} size="small" disabled={disabled}
        {...(action.href ? { href: action.href } : { onClick: action.kind === 'mappings' ? onReviewMappings : onReviewSaved })}>{action.label}</Button>)}
    </Stack>}
  </Stack>;
}
